import * as SuperAdmin from 'constants/super-admin';

interface LicenseSortState {
  columnName: string;
  desc: boolean;
}

// Action carries sort/selection fields; typed minimally at the reducer boundary.
interface LicenseSortAction {
  type: string;
  columnName?: string;
  desc?: boolean;
  name?: string;
}

const defaultInstitutionalState: LicenseSortState = {
  columnName: 'servicePeriod',
  desc: true,
};

const defaultIndividualState: LicenseSortState = {
  columnName: 'servicePeriod',
  desc: false,
};

export const LicenseSortReducer = (
  state: LicenseSortState = defaultInstitutionalState,
  action: LicenseSortAction,
): LicenseSortState => {
  switch (action.type) {
    case SuperAdmin.SORT_ACTION_TYPES.SORT:
      return {
        columnName: action.columnName as string,
        // Toggle current `desc` if toggling current column, defer to incoming  `desc` if selecting
        // new column:
        desc: state.columnName === action.columnName ? !state.desc : (action.desc as boolean),
      };
    // When changing tool, reset sort state depending on table type:
    case SuperAdmin.SELECTOR_ACTION_TYPES.SELECT_TOOL:
      if (action.name === SuperAdmin.TOOL_BUTTON_NAMES.INDIVIDUAL_LICENSE) {
        return defaultIndividualState;
      }
      if (action.name === SuperAdmin.TOOL_BUTTON_NAMES.INSTITUTION_LICENSE) {
        return defaultInstitutionalState;
      }
      return state;
    default:
      return state;
  }
};
